/**
 * Used for diplaying WYSIWYG text like product abstract and description
 */

import draftToHtml from 'draftjs-to-html';

export default function convertToHtml(str:string){
    
	if (str !== null) {
        try {
            const uiSchema = JSON.parse(str);
            return draftToHtml(uiSchema)
        } catch (e) {
            return str;
        }
    } else {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/common/fragments/ConvertToHtml.tsx